/*
状态对象模块
 */
export default {
  httpError: {
    hasError: false,
    status: '',
    statusText: ''
  },
  user:{},
  currAreaCode: {},
  tomcatInfo: {},
}



// WEBPACK FOOTER //
// ./src/vuex/state.js